<template>
  <div id="app">
    <additional-items />
  </div>
</template>

<script>
import AdditionalItems from './components/additional.items.vue'

export default {
  name: 'App',
  components: {
    AdditionalItems
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
  width:100%;
}
</style>
